import { useState } from "react";
import { BsXLg } from "react-icons/bs";
import headerLogo from "../../../assets/images/header-logo.svg";
import MobileMenuStyleWrapper from "./MobileMenu.style";
import { useNavigate } from "react-router-dom";

const MobileMenu = ({ mobileMenuhandle }) => {
  const [isSubmenu, setSubmenu] = useState(false);
  const navigate = useNavigate();

  const handleSubmenu = () => {
    setSubmenu(!isSubmenu);
  };

  const navigateTo = (path) => {
    window.scrollTo(0, 0);
    navigate(path);
  }

  return (
    <MobileMenuStyleWrapper className="mobile_menu">
      <div className="mobile_menu_content">
        <div className="menu_logo">
          <img className="logo" src={headerLogo} alt="logo" />
          <button
            className="menu_close_btn"
            onClick={() => mobileMenuhandle()}
          >
            {" "}
            <BsXLg />{" "}
          </button>
        </div>
        <div className="mobile_menu_list">
          <ul>
            <li className="mobile_menu_hide">
              <p onClick={() => navigateTo("/")}>Home</p>
            </li>
            <li className="mobile_menu_hide">
              <a href="#about">About</a>
            </li>
            <li className="mobile_menu_hide">
              <a href="#blog">Blog</a>
            </li>
            <li className="mobile_menu_hide">
              <a href="#features">Features</a>
            </li>
            <li className="mobile_menu_hide">
              <p onClick={() => navigateTo('/contact')}>Contact Us</p>
            </li>
            <li className="submenu mobile_submenu" onClick={handleSubmenu}>
              <p>Pages +</p>
              {
                isSubmenu && (
                  <>
                    <ul className={`sub_menu_list mobile_sub_menu_list`} >
                      <li>
                        <p onClick={() => navigateTo('/team')}>Team</p>
                      </li>
                      <li>
                        <p onClick={() => navigateTo('/services')}>Services</p>
                      </li>
                      <li>
                        <p onClick={() => navigateTo('/features')}>Features</p>
                      </li>
                      <li>
                        <p onClick={() => navigateTo('/terms-condition')}>Terms & Condition</p>
                      </li>
                      <li>
                        <p onClick={() => navigateTo('/faq')}> FAQs </p>
                      </li>
                      <li>
                        <p onClick={() => navigateTo('/about')}>About Us </p>
                      </li>
                      <li>
                        <p onClick={() => navigateTo('/blogs')}>Latest Blog</p>
                      </li>
                      <li>
                        <p onClick={() => navigateTo('/post')}>Blog Details</p>
                      </li>
                      <li>
                        <p href="/contact" onClick={() => navigateTo('/contact')}>Contact</p>
                      </li>
                    </ul>
                  </>
                )
              }
            </li>
          </ul>
        </div>
      </div>
    </MobileMenuStyleWrapper>
  );
};

export default MobileMenu;
